import React, { useState, useRef } from 'react';
import { useSpring, animated } from 'react-spring';
import openEye from '../assets/icons/eyeopen1.svg';
import closeEye from '../assets/icons/eyeclose.svg';
import { cn } from '../utils/cn';

interface TextInputFieldProps {
  label: string;
  password?: boolean;
  onTextChange?: (text: string) => void;
  errorMessage?: string;
  className?: string;
}

export const InputField: React.FC<TextInputFieldProps> = ({ label, password = false, onTextChange, errorMessage, className, ...props }) => {
  const [inputText, setInputText] = useState("");
  const [hidePass, setHidePass] = useState(true);
  const [isInputFocused, setInputFocused] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const isFocused = isInputFocused || inputText !== "";

  const { fontSize, top } = useSpring({
    fontSize: isFocused ? '12px' : '14px',
    top: isFocused ? '5px' : '16px',
  });

  const handleLabelClick = () => {
    setInputFocused(true);
    inputRef.current?.focus();
  };

  return (
    <div className={cn([`px-2 py-2.5 rounded-xl w-full bg-white relative border ${errorMessage ? "border-red-500" : "border-white"}`], className)} onClick={handleLabelClick}>
      <animated.label
        style={{ fontSize, top, position: 'absolute', left: '16px' }}
        className={`font-medium text-[#9392A2] ${errorMessage && "text-red-500"}`}
      >
        {errorMessage ? errorMessage: label}
      </animated.label>
      <input
        {...props}
        ref={inputRef}
        type={password && hidePass ? 'password' : 'text'}
        className="mt-2 text-sm font-medium text-black w-full outline-none pl-2 pt-1"
        onFocus={() => setInputFocused(true)}
        onBlur={() => setInputFocused(false)}
        onChange={(e) => {
          setInputText(e.target.value);
          onTextChange && onTextChange(e.target.value);
        }}
      />
      {password && (
        <div className="absolute right-4 top-7 transform -translate-y-1/2">
          <button onClick={(e) => { e.stopPropagation(); setHidePass(!hidePass); }}>
            {hidePass ? <img src={openEye} className="w-6" alt="openEye" /> : <img src={closeEye} className="w-6 mt-[4.8px]" alt="openEye" />}
          </button>
        </div>
      )}
    </div>
  );
};